// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UA2u","top":"styles_top__Bo-h_","left":"styles_left__l51ur","description":"styles_description__2yOoY"};